import { defineMessages } from 'react-intl';

export const locale = defineMessages({
  areYouSure: {
    id: 'add-ons.table.are-you-sure',
    description: 'Information about deleting an add on.',
    defaultMessage: 'Are you sure you want to delete this add-on?'
  },
  createAddOn: {
    id: 'add-ons.table.create-add-on',
    description: 'Create an add-on',
    defaultMessage: 'Create add-on'
  },
  createEvent: {
    id: 'add-ons.table.create-event',
    description: 'Create an add-on',
    defaultMessage: 'Create an event'
  },
  active: {
    id: 'add-ons.table.header.active',
    description: 'Status of add-on',
    defaultMessage: 'Active'
  },
  addOnName: {
    id: 'add-ons.table.header.name',
    description: 'Name of add-on',
    defaultMessage: 'Add-on'
  },
  price: {
    id: 'add-ons.table.header.price',
    description: 'Price of add-on',
    defaultMessage: 'Price'
  },
  available: {
    id: 'add-ons.table.header.availability',
    description: 'avilability of add-on',
    defaultMessage: 'Availability'
  },
  appliesTo: {
    id: 'add-ons.table.header.applies-to',
    description: 'Events where add-on applies to',
    defaultMessage: 'Applies to'
  },
  errorFlashMessage: {
    id: 'add-ons.errorFlashMessage',
    description: '',
    defaultMessage: 'Oops! Something went wrong. Please try again.'
  },
  actions: {
    id: 'add-ons.table.header.actions',
    description: 'Add-on actions',
    defaultMessage: 'Action'
  },
  allEventsAndTickets: {
    id: 'add-ons.table.row.all-events',
    description: 'Applies to all event and ticket types',
    defaultMessage: 'All {currencyCode} events'
  },
  allOrSomeEventsAndTickets: {
    id: 'add-ons.table.row.all-or-some-events',
    description: 'Applies to all or some event and ticket types',
    defaultMessage: '{listingsCountText} {currencyCode} events'
  },
  emptyAddOns: {
    id: 'add-ons.empty-addons',
    description: 'When the user doesn\'t have any add-ons',
    defaultMessage: 'You can start selling add-ons to your events and be able to track the inventory. Get started now'
  },
  emptyEvents: {
    id: 'add-ons.empty-events',
    description: 'When the user doesn\'t have any events',
    defaultMessage: 'Oops! You\'ll need to create an event first before you can create an add-on.'
  },
  emptyAddOnsState: {
    id: 'add-ons.empty-addons-state',
    description: 'When the user doesn\'t specific state add-ons',
    defaultMessage: 'Hmm, it doesn’t look like any add-ons match your filters'
  },
  free: {
    id: 'add-ons.free',
    description: '',
    defaultMessage: 'Free'
  },
  options: {
    id: 'add-ons.table.header.options',
    description: 'Add on options',
    defaultMessage: 'Options'
  },
  unlimited: {
    id: 'add-ons.unlimited',
    description: '',
    defaultMessage: 'Unlimited'
  },
  soldOut: {
    id: 'add-ons.sold-out',
    description: '',
    defaultMessage: 'Sold out'
  },
  allTicketTypesSelectedIndicators: {
    id: 'add-ons.allTicketTypesSelectedIndicators',
    description: 'All ticket types',
    defaultMessage: 'All ticket types',
  },
  specificTicketTypesSelectedIndicators: {
    id: 'add-ons.specificTicketTypesSelectedIndicators',
    description: 'Specific ticket types',
    defaultMessage: 'Specific ticket types',
  },
  noAddOnsFound: {
    id: 'add-ons.noAddOnsFound',
    description: 'AddOns not found',
    defaultMessage: 
      'You don’t have any add-ons yet.\n Once you create an add-on, it will be displayed in this section.',
  },
  noAddOnsFoundWithFilter: {
    id: 'add-ons.noAddOnsFoundWithFilter',
    description: 'AddOns not found with filters',
    defaultMessage: 'No results found\n Try adjusting your search, changing or removing filters.',
  },
  removeAllFilters: {
    id: 'add-ons.removeAllFilters',
    description: 'Remove all filters',
    defaultMessage: 'Remove all Filters',
  },
  noOptions: {
    id: 'add-ons.noOptions',
    description: 'None',
    defaultMessage: 'None',
  },
  addOnSearchPlaceholder: {
    id: 'add-ons.addOnSearchPlaceholder',
    description: 'Search add-on',
    defaultMessage: 'Search add-on',
  },
  eventSearchPlaceholder :  {
    id: 'add-ons.eventSearchPlaceholder',
    description: 'Filter by event',
    defaultMessage: 'Filter by event',
  },
  oneEventSelected: {
    id: 'add-ons.table.row.one-event',
    description: 'Applies to one event',
    defaultMessage: '{listingsCountText} {currencyCode} event'
  },
  allRatesSold: {
    id: 'add-ons.table.row.all-option-sold',
    description: 'Applies to one option',
    defaultMessage: 'This add-on is sold out. Change add-on quantity to resume selling.'
  },
  multiRatesSold: {
    id: 'add-ons.table.row.multi-option-sold',
    description: 'Applies to multiple option',
    defaultMessage: 'This add-on option is sold out. Change add-on option quantity to resume selling.'
  },
  allTimeslot: {
    id: 'add-ons.table.row.all-timeslot',
    description: 'All timeslots',
    defaultMessage: 'All timeslots'
  },
  specificTimeslot: {
    id: 'add-ons.table.row.specific-timeslot',
    description: 'Specific timeslots',
    defaultMessage: 'Specific timeslots'
  },
  cannotDeleteSoldAddOn: {
    id: 'add-ons.table.row.cannot-delete-sold-add-on',
    description: 'Tooltip shown on the disabled delete icon when an add-on has been sold',
    defaultMessage: 'You cannot delete an add-on that has already been sold.'
  },
});
